export const createDownloadFile = (name: string, data: string) => {
    let url;

    if (data) {
        const blob = new Blob([data], { type: "text/plain" });
        url = URL.createObjectURL(blob);
    }

    const link = document.createElement("a");

    if (link && name && url) {
        link.download = name;
        link.href = url;
        link.click();
    }
};
